import React, { Component } from 'react';
//import ClampText from '../../utility/ClampText';

class ItemSelecionarConteudo extends Component {
    render() {
        return (<>
            <div className={"adap-light-gray edb-round edb-margin-bottom edb-padding " + (this.props.selected ? " edb-border-left adap-border-green" : "")}>

                <div className="edb-row edb-padding-small-left">
                    <div className="edb-col s8">
                        <div className="edb-inline edb-margin-right">
                            {/* <input type="checkbox" className="edb-margin-small-right" /> */}
                            <span className="edb-text-bold">{this.props.titulo}</span>
                        </div>
                        <div className="edb-small">
                            {this.props.dificuldade} | {this.props.disciplina}
                        </div>
                    </div>
                    <div className="edb-col s4 edb-right-align">
                        <div className="edb-small adap-green edb-tag edb-round edb-padding-small">{this.props.tipo}</div>
                    </div>
                </div>

                {this.props.porcentagemDeficiencia > 0 && <div className="edb-margin-small-top edb-small">
                    <i className="fas fa-exclamation-triangle adap-text-red edb-margin-small-right"></i>
                    <strong>{this.props.porcentagemDeficiencia}%</strong>
                    <span> dos seus alunos estão com deficiência nesta área.</span>
                </div>}

                <div className="edb-row edb-margin-small-top">
                    {this.props.img && <div className="edb-col s4">
                        <div className="adap-item-conteudo-img adap-light-gray" style={{backgroundPositionY: '-32px'}}>
                            <img src={this.props.img} width="100%" alt="" className="adap-hide-broken-image edb-padding-right" />
                        </div>
                    </div>}
                    <div className={"edb-col" + (this.props.img ? " s8" : " s12")}>
                        <strong className="edb-small">Habilidades:</strong>
                        {(this.props.habilidades || []).map((item, idx) =>
                            <div className="edb-small" key={"habilidade-" + idx}>{item}</div>
                        )}

                    </div>
                    <div>
                        <div className="edb-btn-link adap-text-blue edb-text-bold" onClick={() => this.props.onClickVisualizar && this.props.onClickVisualizar("id")}>Visualizar conteúdo</div>
                    </div>
                </div>
            </div>


            {/* <div className="adap-item-conteudo edb-hide-small edb-hide-medium edb-padding-small edb-margin-bottom edb-inline " onClick={this.props.onClick} >
                <div className="adap-medium-gray edb-small edb-center">{this.getTipoConteudo(this.props.tipo)}</div>
                <div className=" adap-light-gray">
                    <img src={this.props.img} alt={this.props.titulo} width="100%" />
                </div>
                <div className="edb-padding-small">
                    <div className="edb-row">
                        <div className="edb-col s8">{this.props.disciplina}</div>
                        <div className="edb-col s4 edb-right-align adap-text-green">
                            {this.props.porcentagem > 0 && this.props.porcentagem < 100 && <span> <i className="far fa-dot-circle"></i> {this.props.porcentagem}%</span>}
                            {this.props.porcentagem === 100 && <span><i className="far fa-check-circle"></i> {this.props.porcentagem}%</span>}
                        </div>
                    </div>
                    <div className="edb-text-bold">{ClampText(this.props.titulo, 60)}</div>
                    <div className="edb-small"><span className="edb-text-bold">{this.props.qtd}</span> {this.getDescricaoTipo(this.props.tipo)}, <span className="edb-text-bold">{this.props.pontos}</span> pontos</div>
                    {this.props.dataLimite && <div className="edb-small">Limite <b>{this.props.dataLimite}</b></div>}
                </div>
            </div> */}

        </>);
    }
}

export default ItemSelecionarConteudo;